<script lang="ts">
  import DotLoader from 'src/components/loaders/dot-loader.svelte';
  import PoweredBy from 'src/components/powered-by.svelte';
  import {
    bizReviewStore,
    getBizReviews,
  } from 'src/stores/biz-reviews/biz-review-store';
  import {
    floatingWidgetSettingsStore,
    getFloatingWidgetSettings,
  } from 'src/stores/floating-widget-settings-store';
  import { trackMarquee } from 'src/utils/telemetry';
  import { getTextColorFromBGHex } from 'src/utils/theme-text';
  import MarqueeList from './marquee-list.svelte';

  export let businessKey: string;

  let bizReviews = [];
  let loaded = false;
  let isCelebrity = false;
  let isFetchingReviews = false;

  let marqueeContainerWidth: number;
  let marqueeTrackHeight: number;
  let marqueeTrackListWidth: number;
  $: animateMarqueeTrack = marqueeTrackListWidth >= marqueeContainerWidth;
  $: marqueeContainerHeight = marqueeTrackHeight;

  bizReviewStore.subscribe((value) => {
    bizReviews = value.displayData;

    isFetchingReviews = value.loading;
  });

  getBizReviews(businessKey);

  // ==== Widget settings ===
  let themeColor = null;
  $: themeStyle =
    (themeColor &&
      `--primary: ${themeColor}; --theme-text-color: ${getTextColorFromBGHex(
        themeColor,
      )};`) ||
    '';
  getFloatingWidgetSettings(businessKey);

  floatingWidgetSettingsStore.subscribe((value) => {
    themeColor = value.themeColor;
    isCelebrity = value.metaData.celebrity;
  });

  // ==== On Load ===
  function onLoad() {
    if (loaded) return;

    trackMarquee('default', businessKey);
    loaded = true;
  }

  $: {
    if ($floatingWidgetSettingsStore.loaded && bizReviews.length) {
      onLoad();
    }
  }

  $: marqueeStyle = `${themeStyle} height: ${marqueeContainerHeight}px;`;
</script>

<div
  style={marqueeStyle}
  class={`marqueeContainer ${animateMarqueeTrack ? 'animated' : null}`}
  bind:clientWidth={marqueeContainerWidth}
>
  {#if loaded}
    <div
      class={`marqueeTrack ${animateMarqueeTrack ? 'animated' : null}`}
      bind:clientHeight={marqueeTrackHeight}
    >
      <MarqueeList
        bind:width={marqueeTrackListWidth}
        {businessKey}
        {isCelebrity}
        reviews={bizReviews}
      />

      {#if animateMarqueeTrack}
        <MarqueeList
          class="secondMarqueeTrack"
          {businessKey}
          {isCelebrity}
          reviews={bizReviews}
        />
      {/if}
    </div>
  {/if}
</div>

{#if isFetchingReviews}
  <div class="loaderContainer mt-md">
    <DotLoader />
  </div>
{/if}

{#if loaded}
  <div class="poweredByContainer">
    <PoweredBy class="poweredBy rounded-borders pa-sm mt-md" />
  </div>
{/if}

<style lang="scss">
  $maskImage: linear-gradient(
    to right,
    transparent 0%,
    black 10%,
    black 90%,
    transparent 100%
  );

  .marqueeContainer {
    position: relative;
    overflow: hidden;

    &.animated {
      mask-image: $maskImage;
      -webkit-mask-image: $maskImage;
    }
  }

  .marqueeTrack {
    position: absolute;
    display: flex;

    &.animated {
      animation: maqueeTrackAnimation 90s linear infinite;
    }

    &:hover {
      animation-play-state: paused;
    }
  }

  :global(.secondMarqueeTrack) {
    margin-left: 8px;
  }

  .loadMoreButton {
    background-color: var(--primary);
    color: var(--theme-text-color);
    border: 1px solid var(--primary);
    padding: 8px;
    cursor: pointer;
  }

  .loaderContainer {
    display: flex;
    justify-content: center;
  }

  .poweredByContainer {
    display: flex;
    justify-content: center;

    :global(.poweredBy) {
      background-color: rgba(255, 255, 255, 0.4);
      backdrop-filter: saturate(180%) blur(20px);
    }
  }

  @keyframes maqueeTrackAnimation {
    0% {
      transform: translateX(0%);
    }

    100% {
      transform: translateX(-50%);
    }
  }
</style>
